module.exports.Destinations = {
  sylt: {
    name: 'Sylt',
    translations: {
      de: {
        name: 'Sylt'
      },
      en: {
        name: 'Sylt'
      }
    }
  },
  ruegen: {
    name: 'Rügen',
    translations: {
      de: {
        name: 'Rügen'
      },
      en: {
        name: 'Rügen'
      }
    }
  },
  texel: {
    name: 'Texel',
    translations: {
      de: {
        name: 'Texel'
      },
      en: {
        name: 'Texel'
      }
    }
  },
  allgaeu: {
    name: 'Allgäu',
    translations: {
      de: {
        name: 'Allgäu'
      },
      en: {
        name: 'Allgäu'
      }
    }
  },
  garda: {
    name: 'Gardaseee',
    translations: {
      de: {
        name: 'Gardasee'
      },
      en: {
        name: 'Lake Garda'
      }
    }
  },
  mallorca: {
    name: 'Mallorca',
    translations: {
      de: {
        name: 'Mallorca'
      },
      en: {
        name: 'Mallorca'
      }
    }
  }
}